export default __webpack_public_path__ + "static/media/Img068.aa501a74.jpg";